export default __webpack_public_path__ + "static/media/PPI-patio-024.bb6c9416.jpg";